// usePoolUI.ts
import { useState, useEffect } from "react";

import eventBus from "../event_bus";  
import { PoolColor } from "./components/color_swatch"; 
import { MultiSelectOption } from "./components/row";  
import { poolTypesOptions } from "./pool_ui_props";

export const poolUIViewModel = (defaultColor:PoolColor) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPanelVisible, setPanelVisible] = useState(false);
  const [length, setLength] = useState(7);
  const [width, setWidth] = useState(3);
  const [depth, setDepth] = useState(1.5);
  const [isDay, setIsDay] = useState(true);
  const [poolType, setPoolType] = useState("std");
  const [poolTypeName, setPoolTypeName] = useState("Skimmer");
  const [numSpots, setNumSpots] = useState(1);
  const [useBeach, setUseBeach] = useState(true);
  const [floatingStairs, setFloatingStairs] = useState(false);
  const [useEdgeless, setUseEdgeless] = useState(false);
  const [stairType, setStairType] = useState("Pure" as string);
  const [poolCoverType, setPoolCoverType] = useState("None" as string);
  const [coverSystem, setCoverSystem] = useState("Plage" as string);
  const [selectedColor, setSelectedColor] = useState<PoolColor | null>(
    defaultColor
  );

  useEffect(() => {
    // Function to set isMobile based on window width
    const handleResize = () => {
      if (window.innerWidth < 640) { // 640px can be your mobile breakpoint
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
  
    // Initial check
    handleResize();
  
    // Set up event listener
    window.addEventListener('resize', handleResize);
  
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const togglePanelVisibility = () => {
    setPanelVisible(!isPanelVisible);
  };

  const handleLengthChange = (value: number) => {
    setLength(value);
    eventBus.emit("updateDimensions", { length: value, width, depth }); 
  };

  const handleWidthChange = (value: number) => {
    setWidth(value);
    eventBus.emit("updateDimensions", { length, width: value, depth }); 
  };

  const handleDepthChange = (value: number) => {
    setDepth(value);
    eventBus.emit("updateDimensions", { length, width, depth: value }); 
  };

  const handleColorSelection = (color: PoolColor) => {
    setSelectedColor(color); 
    eventBus.emit("updateColor", color.valueColor);
  };

  const toggleDayNight = () => {
    setIsDay(!isDay);
    eventBus.emit("updateLightingMode", !isDay ? "day" : "night");
  };

  
  

  const handleEditorModeToggle = (value: boolean) => {
    eventBus.emit("updateResizeMode", value); 
  };

  const handleEdgelessToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setUseEdgeless(checked);
    eventBus.emit("onEdgelessToggle", checked);
  };

  const handlePoolTypeSelection = (
    selectedOption: MultiSelectOption,
  ) => {
    setPoolType(String(selectedOption.data));
    setPoolTypeName(String(selectedOption.display))
    eventBus.emit("updatePoolType", selectedOption.data);
  };

  const handlePoolTypeSelectionSide = (
    selectedOption: string,
  ) => {

    const selectedOpt = poolTypesOptions.find((opt) => opt.data === selectedOption);
    setPoolType(String(selectedOption));
    setPoolTypeName(String(selectedOpt.display))
    eventBus.emit("updatePoolType", selectedOption);
  };

  const handleStairType = (
    selectedOption: MultiSelectOption | string,
  ) => {

    if (typeof selectedOption === 'string') {
      selectedOption = selectedOption as string;
      setStairType(String(selectedOption));
      eventBus.emit("updateStairType", selectedOption);
    }
    else {
      selectedOption = selectedOption as MultiSelectOption;
      setStairType(String(selectedOption.data));
      eventBus.emit("updateStairType", selectedOption.data);
    }
    
    
  }

  

  const handleNumSpotsChange = (value: number) => {
    setNumSpots(value);
    eventBus.emit("updateNumSpots", value); 
  };

  const handlePoolCoverType = (selectedOption: String) => {
    console.log('handlePoolCoverType', selectedOption);
    setPoolCoverType(String(selectedOption));
  };

  const handleCoverSystem = (selectedOption: String) => {
    setCoverSystem(String(selectedOption));
  };


  const handleSidePanelToggle = () => {
    togglePanelVisibility();
  };

  const handleUseBeach = (useBeach:boolean) => {
    setUseBeach(useBeach);
    eventBus.emit("updateUseBeach", useBeach);
  }



  const handleFactorySettingsSize = (selectedOption: MultiSelectOption,) => {

    const sizeAsStr = String(selectedOption.data);
    const depth = 2.0;
    const split = sizeAsStr.split(":");
    const length = parseFloat(split[0]);
    const width = parseFloat(split[1]);

    setLength(length);
    setWidth(width);
    setDepth(depth);
    eventBus.emit("updateDimensions", { length, width, depth });
  };

  const handleFloatingStairsToggle = (e:boolean) => {
    setFloatingStairs(e);
    eventBus.emit("updateUseFloatingStairs", e);
  };

  return {
    isMobile,
    isPanelVisible,
    togglePanelVisibility,
    length,
    handleLengthChange,
    width,
    handleWidthChange,
    depth,
    handleDepthChange,
    isDay,
    toggleDayNight,
    poolType,
    handlePoolTypeSelection,
    poolTypeName,

    numSpots,
    handleNumSpotsChange,
    useEdgeless,
    handleEdgelessToggle,
    stairType,
    handleStairType,
    selectedColor,
    handleColorSelection,
    handleEditorModeToggle,
    handleSidePanelToggle,

    poolCoverType,
    handlePoolCoverType,
    coverSystem,
    handleCoverSystem,
    handleFactorySettingsSize,
    useBeach,
    handleUseBeach,
    floatingStairs,
    handleFloatingStairsToggle,
    handlePoolTypeSelectionSide
  };
};